<template>
  <div>
    <h1 :class="$style.pageTitle">Monetization</h1>
    <Message :class="$style.warningBanner" severity="warn" :closable="false">
      Shops and Offers require VoodooLive integration to function in your game. See our
      <a
        href="https://www.notion.so/voodoo/VoodooLive-1dda0b481db48020bf30cd1c915927aa"
        target="_blank"
        rel="noopener noreferrer"
        :class="$style.docLink"
      >
        documentation
      </a>
      for setup instructions.
    </Message>
    <RouterTabs :tabs="tabs" :tab-with-children-routes="['offer-campaigns']" />
    <router-view></router-view>
  </div>
</template>

<script setup lang="ts">
import RouterTabs from "@/components/RouterTabs";
import useFeatureFlags from "@/hooks/useFeatureFlags";
import links from "@/router/links";
import Message from "primevue/message";

import { ref } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const gameId = ref(route.params.gameId as string);
const { flags } = useFeatureFlags(gameId.value);

const tabs = ref([
  { path: "./items", label: "Items", name: links.offersAndStore.tabs.items },
  { path: "./rewards", label: "Rewards", name: links.offersAndStore.tabs.rewards },
  { path: "./store", label: "Shop", name: links.offersAndStore.tabs.store },
  ...(flags.value?.campaignsRevamp?.enabled
    ? [
        {
          path: "./offer-campaigns",
          label: "Offer campaigns",
          name: links.offersAndStore.tabs.offerCampaigns.campaignList,
        },
      ]
    : [{ path: "./offers", label: "Offers", name: links.offersAndStore.tabs.offers }]),
]);
</script>

<style module>
.pageTitle {
  font-size: 32px;
  font-weight: 700;
}

.warningBanner {
  margin-bottom: 1rem;
}

.docLink {
  color: inherit;
  font-weight: 600;
  text-decoration: underline;
}
</style>
